import { externalConstraint } from '@flatfile/plugin-constraints'
import { IRA_AMOUNT } from '../config/iraAmount'
import { iraAmountValidator, recordkeeperListener } from './listeners'
import {
  dateOfOriginalDistributionFormattingListener,
  wasTaxWithheldFormattingListener,
  dateOfOriginalDistributionValidationListener,
  wasTaxWithheldValidationListener,
} from './uncashedChecksPaticipantsDataFormatting'
import {
  planEinFormattingListener,
  planSponsorFormattingListener,
  planNameFormattingListener,
  planIdNumberFormattingListener,
  planNumberFormattingListener,
  zipCodeFormattingListener,
  dobFormattingListener,
  dobValidationListener,
  ssnFormattingListener,
  ssnValidationListener,
  countryCodeFormattingListener,
  stateFormattingListener,
  traditionalIraPreTaxAmountFormattingListener,
  rothIraAmountFormattingListener,
  emailAddressValidationListener,
  countryCodeStateCityZipValidationListener,
} from './participantsDataFormatting'

export const uncashedChecksParticipantListeners = (listener, userAudience) => {
  /*Data Formatting*/

  // PlanEin formatting
  planEinFormattingListener(listener, 'participant-record')

  // PlanSponsor formatting
  planSponsorFormattingListener(listener, 'participant-record')

  // PlanName formatting
  planNameFormattingListener(listener, 'participant-record')

  //PlanIdNumber formatting
  planIdNumberFormattingListener(listener, 'participant-record')

  //PlanNumber formatting
  planNumberFormattingListener(listener, 'participant-record')

  //ZipCode formatting
  zipCodeFormattingListener(listener, 'participant-record')

  //DOB formatting
  dobFormattingListener(listener, 'participant-record')
  dobValidationListener(listener, 'participant-record')

  //SSN formatting
  ssnFormattingListener(listener, 'participant-record')
  ssnValidationListener(listener, 'participant-record')

  //CountryCode formatting
  countryCodeFormattingListener(listener, 'participant-record')

  //State formatting
  stateFormattingListener(listener, 'participant-record')

  //Traditional IRA Pre-tax formatting
  traditionalIraPreTaxAmountFormattingListener(listener, 'participant-record')

  //Roth IRA formatting
  rothIraAmountFormattingListener(listener, 'participant-record')

  // Date of Original Distribution formatting
  dateOfOriginalDistributionFormattingListener(listener, 'participant-record')
  dateOfOriginalDistributionValidationListener(listener, 'participant-record')

  // Was Tax Withheld formatting
  wasTaxWithheldFormattingListener(listener, 'participant-record')
  wasTaxWithheldValidationListener(listener, 'participant-record')

  /*Constraints*/

  // Country and State validation
  countryCodeStateCityZipValidationListener(listener, 'participant-record')

  // Email Address Validation
  emailAddressValidationListener(listener, 'participant-record')

  listener.use(
    externalConstraint('recordKeeper', (value, key, { config, record }) => {
      if (value && new RegExp(config.noSlashRegex.regex).test(value)) {
        record.addError(key, config.noSlashRegex.error)
      }
      if (
        value &&
        new RegExp(config.createMaxCharValidator.regex).test(value)
      ) {
        record.addError(key, config.createMaxCharValidator.error)
      }
      if (
        value &&
        new RegExp(config.createEmptyValueValidator.regex).test(value)
      ) {
        record.addError(key, config.createEmptyValueValidator.error)
      }
    })
  )

  recordkeeperListener(listener, 'participant-record')

  listener.use(
    externalConstraint('tpa', (value, key, { config, record }) => {
      if (value && new RegExp(config.noSlashRegex.regex).test(value)) {
        record.addError(key, config.noSlashRegex.error)
      }
      if (
        value &&
        new RegExp(config.createMaxCharValidator.regex).test(value)
      ) {
        record.addError(key, config.createMaxCharValidator.error)
      }
      if (userAudience !== 'Recordkeeper') {
        if (
          value &&
          new RegExp(config.createEmptyValueValidator.regex).test(value)
        ) {
          record.addError(key, config.createEmptyValueValidator.error)
        }
      }
    })
  )

  listener.use(
    externalConstraint('planSponsor', (value, key, { config, record }) => {
      if (value && new RegExp(config.noSlashRegex.regex).test(value)) {
        record.addError(key, config.noSlashRegex.error)
      }
      if (
        value &&
        new RegExp(config.createMaxCharValidator.regex).test(value)
      ) {
        record.addError(key, config.createMaxCharValidator.error)
      }
      if (
        value &&
        new RegExp(config.createEmptyValueValidator.regex).test(value)
      ) {
        record.addError(key, config.createEmptyValueValidator.error)
      }
    })
  )

  listener.use(
    externalConstraint('planName', (value, key, { config, record }) => {
      if (value && new RegExp(config.noSlashRegex.regex).test(value)) {
        record.addError(key, config.noSlashRegex.error)
      }
      if (
        value &&
        new RegExp(config.createMaxCharValidator.regex).test(value)
      ) {
        record.addError(key, config.createMaxCharValidator.error)
      }
      if (userAudience !== 'Recordkeeper') {
        if (
          value &&
          new RegExp(config.createEmptyValueValidator.regex).test(value)
        ) {
          record.addError(key, config.createEmptyValueValidator.error)
        }
      }
    })
  )

  listener.use(
    externalConstraint('zipCode', (value, key, { config, record }) => {
      if (
        value &&
        new RegExp(config.createMaxCharValidator.regex).test(value)
      ) {
        record.addError(key, config.createMaxCharValidator.error)
      }
    })
  )

  listener.use(
    externalConstraint('countryCode', (value, key, { config, record }) => {
      if (
        value &&
        new RegExp(config.createMaxCharValidator.regex).test(value)
      ) {
        record.addError(key, config.createMaxCharValidator.error)
      }
    })
  )

  listener.use(
    externalConstraint('planEin', (value, key, { config, record }) => {
      if (value && !new RegExp(config.invalidEINFormat.regex).test(value)) {
        record.addError(key, config.invalidEINFormat.error)
      }
      if (value && !new RegExp(config.invalidEIN.regex).test(value)) {
        record.addError(key, config.invalidEIN.error)
      }
    })
  )

  listener.use(
    externalConstraint('planNumber', (value, key, { config, record }) => {
      if (value && new RegExp(config.invalidCharacters.regex).test(value)) {
        record.addError(key, config.invalidCharacters.error)
      }
      if (value && !new RegExp(config.mustBeThreeDigits.regex).test(value)) {
        record.addError(key, config.mustBeThreeDigits.error)
      }
    })
  )

  listener.use(
    externalConstraint('planIdNumber', (value, key, { config, record }) => {
      if (
        value &&
        new RegExp(config.createMaxCharValidator.regex).test(value)
      ) {
        record.addError(key, config.createMaxCharValidator.error)
      }
    })
  )

  listener.use(
    externalConstraint('firstName', (value, key, { config, record }) => {
      if (
        value &&
        new RegExp(config.createMaxCharValidator.regex).test(value)
      ) {
        record.addError(key, config.createMaxCharValidator.error)
      }
      if (value && new RegExp(config.checkNamePrefix.regex, 'i').test(value)) {
        record.addError(key, config.checkNamePrefix.error)
      }
      if (
        value &&
        new RegExp(config.checkNotApplicable.regex, 'i').test(value)
      ) {
        record.addError(key, config.checkNotApplicable.error)
      }
      if (
        value &&
        new RegExp(config.createEmptyValueValidator.regex).test(value)
      ) {
        record.addError(key, config.createEmptyValueValidator.error)
      }
    })
  )

  listener.use(
    externalConstraint('middleName', (value, key, { config, record }) => {
      if (
        value &&
        new RegExp(config.createMaxCharValidator.regex).test(value)
      ) {
        record.addError(key, config.createMaxCharValidator.error)
      }
    })
  )

  listener.use(
    externalConstraint('lastName', (value, key, { config, record }) => {
      if (
        value &&
        new RegExp(config.createMaxCharValidator.regex).test(value)
      ) {
        record.addError(key, config.createMaxCharValidator.error)
      }
      if (
        value &&
        new RegExp(config.checkNotApplicable.regex, 'i').test(value)
      ) {
        record.addError(key, config.checkNotApplicable.error)
      }
      if (
        value &&
        new RegExp(config.createEmptyValueValidator.regex).test(value)
      ) {
        record.addError(key, config.createEmptyValueValidator.error)
      }
    })
  )

  listener.use(
    externalConstraint('addressLine1', (value, key, { config, record }) => {
      if (
        value &&
        new RegExp(config.createMaxCharValidator.regex).test(value)
      ) {
        record.addError(key, config.createMaxCharValidator.error)
      }
      if (
        value &&
        new RegExp(config.checkNotApplicable.regex, 'i').test(value)
      ) {
        record.addError(key, config.checkNotApplicable.error)
      }
    })
  )

  listener.use(
    externalConstraint('addressLine2', (value, key, { config, record }) => {
      if (
        value &&
        new RegExp(config.createMaxCharValidator.regex).test(value)
      ) {
        record.addError(key, config.createMaxCharValidator.error)
      }
    })
  )

  listener.use(
    externalConstraint('city', (value, key, { config, record }) => {
      if (
        value &&
        new RegExp(config.createMaxCharValidator.regex).test(value)
      ) {
        record.addError(key, config.createMaxCharValidator.error)
      }
    })
  )

  listener.use(
    externalConstraint('ssn', (value, key, { config, record }) => {
      if (value && new RegExp(config.ssnValidityCheck.regex).test(value)) {
        record.addError(key, config.ssnValidityCheck.error)
      }
    })
  )

  listener.use(
    externalConstraint('emailAddress', (value, key, { config, record }) => {
      if (
        value &&
        new RegExp(config.createMaxCharValidator.regex).test(value)
      ) {
        record.addError(key, config.createMaxCharValidator.error)
      }
    })
  )

  listener.use(
    externalConstraint(
      'traditionalIraPreTaxAmount',
      (value, key, { config, record }) => {
        if (
          value &&
          new RegExp(config.createMaxCharValidator.regex).test(value)
        ) {
          record.addError(key, config.createMaxCharValidator.error)
        }
      }
    )
  )

  listener.use(
    externalConstraint('rothIraAmount', (value, key, { config, record }) => {
      if (
        value &&
        new RegExp(config.createMaxCharValidator.regex).test(value)
      ) {
        record.addError(key, config.createMaxCharValidator.error)
      }
    })
  )

  listener.use(
    externalConstraint('wasTaxWithheld', (value, key, { config, record }) => {
      if (value && !new RegExp(config.wasTaxWithheld.regex).test(value)) {
        record.addError(key, config.wasTaxWithheld.error)
      }
    })
  )

  iraAmountValidator(
    listener,
    'participant-record',
    [IRA_AMOUNT.ROTH],
    IRA_AMOUNT.TRADITIONAL_PRE_TAX,
    'An IRA rollover amount is required'
  )

  iraAmountValidator(
    listener,
    'participant-record',
    [IRA_AMOUNT.TRADITIONAL_PRE_TAX],
    IRA_AMOUNT.ROTH,
    'An IRA rollover amount is required'
  )
}
